<!-- 因子分布情况 -->
<template>
  <div class="shadow">
    <!-- <Table
     height="650"
      class="strategy-detail-table"
      stripe
      :columns="columns"
      :data="records"
      :loading="loading"
    ></Table>-->
    <h3 class="tactics">
      预测能力分析
      <el-date-picker
        size="mini"
        style=" float: right; margin-right: 19px;width: 180px; "
        v-model="valuePicker"
        value-format="yyyy-MM-dd"
        @change="pickerTime"
        type="date"
        placeholder="选择调仓日期"
        :picker-options="picker"
        :default-value="new Date(headerData.startDate)"
      ></el-date-picker>
      <!--  :picker-options="picker" -->
    </h3>
    <div class="tableBox">
      <!-- :data="records.slice( (currentPage - 1) * 20, currentPage * 20 )" -->
      <el-table border :data="tabData" v-loading="loading" style="width: 100%">
        <el-table-column label="证券名称" width="180">
          <template slot-scope="scope">{{scope.row.sID.wstrSymbol}}</template>
        </el-table-column>
        <el-table-column prop="wstrIndustry" label="所属行业"></el-table-column>
        <el-table-column prop="dtDay" label="调仓日期"></el-table-column>
        <el-table-column prop="dbFactorValue" label="因子得分"></el-table-column>
        <el-table-column prop="dbTargetWeight" label="目标权重"></el-table-column>
        <el-table-column prop="dbRealWeight" label="实际权重"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="init"
          @current-change="init"
          :current-page.sync="dataparam.pageInfo.showPage"
          :page-size="20"
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    getData: {
      type: Object,
      required: true,
    },
    getSingle: {
      type: Object,
      required: true,
    },
  },
  data() {
    let than = this;
    return {
       picker: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(than.headerData.startDate).getTime() ||
            time.getTime() > new Date(than.headerData.endDate).getTime()
          );
        },
      },
      valuePicker: "",
      tabData: [],
      currentPage: 1,
      total: 0,
      data: {},
      records: [],
      loading: false,
      headerData:{
          startDate:'',
          endDate:'',
      },
      dataparam: {
        date: "", // 日期,传空字符串请求全部
        factorPerformanceTO: {
          factorName: "", // 因子名称
          investmentDomain: "", // 投资域
        },
        pageInfo: {
          allCount: 0, // 默认
          showNumbers: 20, // 显示多少条
          showPage: 1, // 显示页
        },
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    pickerTime() {
      this.dataparam.pageInfo.showPage = 1;
      if (this.valuePicker) {
        this.dataparam.date = this.valuePicker;
      } else {
        this.dataparam.date = "";
      }
      this.init();
    },
    init() {
      // this.data = this.getData;
      this.dataparam.factorPerformanceTO.factorName = this.getSingle.factorName;
      this.dataparam.factorPerformanceTO.investmentDomain = this.getSingle.investmentDomain;
      this.loading = true;
      this.$api.hubei
        .getSingleFactorAdjustRecordByParm(this.dataparam)
        .then((res) => {
          this.headerData.startDate = res.dateList[0];
          this.headerData.endDate = res.dateList[res.dateList.length-1];
          this.loading = false;
          this.tabData = res.adjustRecordTOList;
          // this.valuePicker = res.dateList[0];
          this.total = res.pageInfo.allCount;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.tableBox {
  background: #fff;
  padding: 20px;
}
.tactics {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  height: 42px;
  line-height: 42px;
  background: rgba(240, 242, 245, 1);
  box-shadow: 0px 0px 8px 0px rgba(239, 242, 255, 1);
  text-shadow: 0px 0px 4px rgba(214, 234, 255, 1);
  padding-left: 10px;
  /deep/ .el-input--mini .el-input__inner {
    height: 30px;
    line-height: 30px;
    width: 180px;
  }
}
.shadow {
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(214, 234, 255, 1);
  padding-bottom: 23px;
  margin-bottom: 20px;
}
.pagination {
  text-align: right;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-top: none;
}
/deep/ .el-table th,
.el-table tr {
  color: #666666;
  text-align: center;
}
/deep/ .el-table td {
  text-align: center;
  color: #666666;
}
/deep/.el-table .warning-row .cell {
  color: #ff5454;
}

/deep/ .el-table .success-row .cell {
  color: #7154ff;
}
/deep/ .el-table td,
/deep/ .el-table th {
  padding: 8px 0;
}
</style>
